import { render, staticRenderFns } from "./MultipleProcesses.vue?vue&type=template&id=3ba49d95&"
import script from "./MultipleProcesses.vue?vue&type=script&lang=js&"
export * from "./MultipleProcesses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports